import { render, staticRenderFns } from "./tagsModal.vue?vue&type=template&id=0784322e&"
import script from "./tagsModal.vue?vue&type=script&lang=js&"
export * from "./tagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports